(() => {
  const header = document.getElementById('pf-home-header');
  if (!header) return;
  const update = () => {
    document.body.classList.toggle('pf-home-overlay', !!document.querySelector('.pfe-hero--immersive'));
    header.classList.toggle('pf-home-header--scrolled', window.scrollY > 60);
    document.documentElement.style.setProperty('--pf-home-header-height', `${header.offsetHeight}px`);
  };
  new ResizeObserver(update).observe(header);
  window.addEventListener('scroll', update, { passive: true });
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('shopify:section:unload', update);
  update();
})();
